import React from 'react';
import Navbar from '../Navbar/Navbar';
import Terms from '../Terms/Terms';
import Footer from '../Footer/Footer';

const TermsPage = () => {
  return (
    <div className='terms-page'>
      <Navbar />
      <Terms />
      <Footer />
    </div>
  );
};

export default TermsPage;
